import axios from "axios";

export function getAllRoles() {
  return axios({
    method: "GET",
    url: "/api/Security/AllRoles",
  });
}

export function fetchRoleSpecificInformation(roleId: number | string) {
  return axios({
    method: "GET",
    url: `/api/Security/RoleSpecificInformation/${roleId}`,
  });
}

export function createOrUpdateRole(updatedRoleInformation: object) {
  return axios({
    method: "POST",
    url: `/api/Security/CreateOrUpdateRoleInformation`,
    data: updatedRoleInformation,
  });
}

export function deleteRole(roleId: number) {
  return axios({
    method: "DELETE",
    url: `/api/Security/DeleteRole/${roleId}`,
  });
}
